import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';

import { BehaviorSubject, Subject } from 'rxjs';
import { filter, take, takeUntil } from 'rxjs/operators';

import { TranslocoService } from '@ngneat/transloco';

import pkg from '@package_json';

import { LayoutService } from '@core/services';

import { environment, info } from '@environment';

interface PackageLicense {
  name: string;
  version: string;
  licenses: string;
  copyright: string;
  repository: string;
  licenseText: string;
}

@Component({
  selector: 'z-about',
  templateUrl: './about.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AboutComponent implements OnInit, OnDestroy {
  destroy$ = new Subject<void>();

  version = `${pkg.version}`;
  environment = environment.name;

  language$ = new BehaviorSubject<string>(this.translocoService.getActiveLang());

  copyrightYear = info.copyrightYear;
  companyName = info.companyName;

  licenses$ = new BehaviorSubject<PackageLicense[]>([]);

  constructor(private http: HttpClient, public layoutService: LayoutService, private translocoService: TranslocoService) {}

  ngOnInit() {
    this.translocoService.langChanges$.pipe(takeUntil(this.destroy$)).subscribe((_lang) => {
      this.language$.next(this.translocoService.getActiveLang());
    });

    this.layoutService.displayAboutDialog$
      .pipe(
        filter((x) => x),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.http
          .get<PackageLicense[]>('./assets/license-data.json')
          .pipe(take(1))
          .subscribe((res) => {
            this.licenses$.next(res);
          });
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  close = () => {
    this.layoutService.displayAboutDialog(false);
  };
}
